import React from 'react';
import { Box } from '@mui/material';
import { align_column, VM_Colors } from '../../Styles/VMStyles';
import MUITypography from '../MUITypography';
import { isEmpty } from '../../Util/UtilHelper';

function FormFieldValues({ title = '', subtitle = '', textColor }) {
  return (
    <Box sx={{ ...align_column, alignItems: 'flex-start', width: '100%', minWidth: 0, maxWidth: '100%' }}>
      <MUITypography
        variant="h4"
        label={title}
        sx={{ color: VM_Colors.steel_gray, fontSize: '14px', fontWeight: 600 }}
        gutterBottom
      />
      <MUITypography
        label={isEmpty(subtitle) ? 'NA' : subtitle}
        sx={{
          fontSize: '1rem',
          fontWeight: 500,
          color: textColor || VM_Colors.black,
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          maxWidth: '100%',
        }}
      />
    </Box>
  );
}

export default FormFieldValues;
